module.exports = __webpack_public_path__ + "assets/svg/Icons/32/sick-callout-gray-66abf4.svg";